import { Component } from '@angular/core';
import { FilterSettings } from '../../../../core/widgets/kw-filter-dropdown/models/filter-options';

export const CycleCountStep = {
  SELECT_AREA: "SELECT_AREA",
  LOCATION_SUMMARY: "LOCATION_SUMMARY",
}

@Component({
  selector: 'cycle-count',
  templateUrl: './cycle-count.component.html',
  styleUrls: ['./cycle-count.component.scss']
})
export class CycleCountComponent {

  public steps = CycleCountStep;
  public selectedStep: string = this.steps.SELECT_AREA;

  public dropdownSettings: FilterSettings = {
    roomSettings: { display: true, singleSelection: true },
    warehouseSettings: { display: true, singleSelection: false },
    locationSettings: { display: true, singleSelection: false }
  };
  // The filter dropdown loads its own options; spin until it first emits.
  public isLoading = true;

  public lottieConfig = {
    path: 'https://res.cloudinary.com/kragworks/raw/upload/v1627967006/HarvestEngine/lottie/select.json',
    renderer: 'canvas',
    autoplay: true,
    loop: true
  };

  setFilterResults() {
    this.isLoading = false;
  }
}
